import * as React from "react";
import { useState } from "react";
import { motion } from "framer-motion";

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

const nav = ['home','about','work','skills','contact']

export const MenuItem = () => {

  return (
    <motion.ul
      variants={variants}
    >
        {nav.map((item)=>(
        <li key={item}>
            <a href={`#${item}`}>{item}</a>
        </li>
        ))}
    </motion.ul>
  );
};
